import { useContext } from "react"
import { CartContext } from "../context/CartContext"
import RecommendedProducts from "../components/RecommendedProducts"
import RecentlyViewed from "../components/RecentlyViewed"
import { useNavigate } from "react-router-dom"

function Cart() {
  const navigate = useNavigate()
  const {
    cart = [],
    removeFromCart,
    updateQty,
    saveForLater,
    saved = [],
    moveToCart
  } = useContext(CartContext)

  /* ✅ SUBTOTAL Calculation Fix: Supporting both formats */
  const subtotal = cart.reduce((total, item) => {
    // 1. Check quantity (qty vs quantity)
    const currentQty = item.quantity || item.qty || 1;
    
    // 2. Check Price (Direct price vs Store API price)
    let currentPrice = 0;
    if (item.price) {
      currentPrice = parseFloat(item.price);
    } else if (item.prices?.price) {
      currentPrice = Number(item.prices.price) / 100;
    }

    return total + (currentPrice * currentQty);
  }, 0);

  /* FREE DELIVERY LOGIC */
  const freeDeliveryLimit = 500
  const remaining = Math.max(freeDeliveryLimit - subtotal, 0)
  const progress = Math.min((subtotal / freeDeliveryLimit) * 100, 100)

  return (
    <div className="cartPage">
      <h1>Shopping Cart</h1>

      <div className="cartLayout">
        {/* LEFT SIDE: ITEMS */}
        <div className="cartItems">
          {cart.length === 0 ? (
            <div className="empty-cart-msg">
               <p>Your cart is empty.</p>
               <button onClick={() => navigate("/")}>Continue Shopping</button>
            </div>
          ) : (
            cart.map(item => {
              // Individual Item Price for display
              const displayPrice = item.price || (item.prices?.price ? Number(item.prices.price) / 100 : 0);
              const displayQty = item.quantity || item.qty || 1;

              return (
                <div className="cartItem" key={item.cartKey || item.id}>
                  <img
                    src={item.image || item?.images?.[0]?.src || "https://via.placeholder.com/150"}
                    className="cartImage"
                    alt={item.name}
                  />

                  <div className="cartInfo">
                    <h3>{item.name}</h3>
                    <div className="cartActions">
                      {/* Use displayQty here */}
                      <button onClick={() => updateQty(item.cartKey || item.id, displayQty - 1)}>-</button>
                      <span>{displayQty}</span>
                      <button onClick={() => updateQty(item.cartKey || item.id, displayQty + 1)}>+</button>
                      <button className="deleteBtn" onClick={() => removeFromCart(item.cartKey || item.id)}>Delete</button>
                      <button className="saveBtn" onClick={() => saveForLater(item)}>Save for later</button>
                    </div>
                  </div>

                  <div className="cartPrice">
                    ₹{parseFloat(displayPrice).toLocaleString('en-IN', { minimumFractionDigits: 2 })}
                  </div>
                </div>
              );
            })
          )}
        </div>

        {/* RIGHT SIDE: SUMMARY */}
        {cart.length > 0 && (
          <div className="cartSummary">
            {remaining > 0 && (
              <div className="deliveryProgress">
                <p>Add <b>₹{remaining.toLocaleString('en-IN')}</b> more for <b>FREE Delivery</b></p>
                <div className="progressBar">
                  <div className="progressFill" style={{ width: progress + "%" }}></div>
                </div>
              </div>
            )}

            <p className="subtotal">
              Subtotal ({cart.length} items): <b>₹{subtotal.toLocaleString('en-IN', { minimumFractionDigits: 2 })}</b>
            </p>

            <button
              className="checkoutBtn"
              onClick={() => navigate("/checkout")}
            >
              Proceed to Checkout
            </button>
          </div>
        )}
      </div>

      {/* SAVED FOR LATER SECTION */}
      {saved.length > 0 && (
        <div className="savedSection">
          <h2>Saved for later</h2>
          <div className="savedGrid">
            {saved.map(item => (
              <div key={item.cartKey || item.id} className="savedItem">
                <img src={item.image || item?.images?.[0]?.src} alt={item.name} />
                <h4>{item.name}</h4>
                <button onClick={() => moveToCart(item)}>Move to Cart</button>
              </div>
            ))}
          </div>
        </div>
      )}

      <RecommendedProducts />
      <RecentlyViewed />
    </div>
  )
}

export default Cart;
